export interface AzanVoice {
  id: string;
  name: string;
  file: string;
}

// Recordings are trimmed and levelled to about −16 LUFS mono. Add a voice with its file in public/azan/.
export const AZAN_VOICES: AzanVoice[] = [
  { id: "makkah", name: "Makkah", file: "/azan/makkah.mp3" },
  { id: "madinah", name: "Madinah", file: "/azan/madinah.mp3" },
  { id: "alquds", name: "Al-Quds", file: "/azan/alquds.mp3" },
  { id: "egypt", name: "Egypt", file: "/azan/egypt.mp3" },
  { id: "turkey", name: "Turkey", file: "/azan/turkey.mp3" },
  { id: "kuwait", name: "Kuwait", file: "/azan/kuwait.mp3" },
  { id: "algeria", name: "Algeria", file: "/azan/algeria.mp3" },
];

// Unknown ids, such as the retired "aaqib-azeez", get the first voice.
export const azanVoice = (id?: string): AzanVoice =>
  AZAN_VOICES.find((voice) => voice.id === id) ?? AZAN_VOICES[0];

export const SHORT_AZAN_SECONDS = 30;
const FADE_SECONDS = 3;

// The "first 30 seconds" choice: fades out over the last few seconds, then ends like a finished
// recording, so the usual "ended" handling tidies up.
export const limitAzan = (sound: HTMLAudioElement, volume: number) => {
  sound.addEventListener("timeupdate", () => {
    const left = SHORT_AZAN_SECONDS - sound.currentTime;
    if (left <= 0) {
      sound.pause();
      sound.dispatchEvent(new Event("ended"));
    } else if (left < FADE_SECONDS) {
      sound.volume = (volume * left) / FADE_SECONDS;
    }
  });
};
